export default function FinalCTA() {
  return (
    <section className="relative py-32 bg-[#0F172A] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/75e6637d22731f34c44b2809ff60891b.jpg"
          alt="AI Infrastructure"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0F172A]/80 via-[#0F172A]/70 to-[#0F172A]/80"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Reinforce Your Operational Core.
        </h2>
        <p className="text-lg md:text-xl text-gray-300 mb-10 leading-relaxed max-w-3xl mx-auto">
          Book a strategy call and discover where precision intelligence can create measurable lift inside your business.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button className="px-8 py-4 bg-white text-[#0F172A] text-base font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap">
            Schedule Consultation
          </button>
          <button className="px-8 py-4 border-2 border-white text-white text-base font-semibold hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap">
            Download Capability Overview
          </button>
        </div>
      </div>
    </section>
  );
}